// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'default-passive-events'

import Vue from 'vue'
import App from './App'
import Element from 'element-ui'
import i18n from './lang'
import { get, post } from './utils/request'
import './permission'
import './icons'

import './styles/element-variables.scss'
import './styles/index.scss'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/iconfont.css'
import './assets/css/base.css'
import echarts from 'echarts'
import menu from 'vue-mouse-menu'
import scroll from 'vue-seamless-scroll' // vue的无缝滚动插件vue-seamless-scroll

import router from './router'
import store from './store'
import './utils/directives.js'
Vue.use(menu)
Vue.use(scroll)// vue的无缝滚动插件vue-seamless-scroll
Vue.use(Element, {
  size: 'mini',
  i18n: (key, value) => i18n.t(key, value)
})
Vue.component('chart', echarts)
Vue.config.productionTip = false
Vue.config.$store = store
Vue.prototype.$get = get
Vue.prototype.$post = post

Vue.directive('has', {

  bind: function(el, binding) {
    if (!Vue.prototype.$_has(binding.value)) {
      el.style.display = 'none'
    }
  }
})
// 权限检查方法
Vue.prototype.$_has = function(value) {
  const buttonperms = store.state.user.btns
  const id = store.state.user.currentRoute
  const roleList = []
  // 权限列表
  for (let j = 0; j < buttonperms.length; j++) {
    if (id === buttonperms[j].parentId) {
      roleList.push(buttonperms[j])
    }
  }
  for (let i = 0; i < roleList.length; i++) {
    if (roleList[i].btnName.indexOf(value) > -1) {
      return true
    }
  }
  return false
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js